var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-full h-auto pb-6 -my-8 -mx-4"},[_c('promotools',{on:{"logoutAffiliate":_vm.logoutAffiliate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }